export default function mouseFocusInfoPlugin() {
  return {
    name: 'mouse-focus-info-command',

    async executeCommand({ command, payload, session }) {
      if (command === 'mouseFocusInfo') {
        if (session.browser.type === 'playwright') {
          const page = session.browser.getPage(session.id);
          const { selector, action } = payload;
          const locator = await page.locator(selector);
          if (!locator) {
            throw new Error(`No element found for selector: ${selector}`);
          }

          if (action === 'mouse') {
            const mouseEl = await locator.count() > 1 ? locator.first() : locator;
            const middlePosition = await mouseEl.evaluate(el => {
              const rect = el.getBoundingClientRect();
              return [
                parseInt(rect.left + rect.width / 2, 10),
                parseInt(rect.top + rect.height / 2, 10),
              ];
            });

            return middlePosition;
          }

          if (action === 'info') {
            const elemProps = await locator.evaluateAll(elems =>
              elems.map(elem => {
                const style = window.getComputedStyle(elem);
                const rect = elem.getBoundingClientRect();

                return {
                  tag: elem.tagName,
                  text: elem.textContent,
                  value: elem.value,
                  isVisible:
                    style.display !== 'none' &&
                    style.visibility !== 'hidden' &&
                    style.opacity !== '0' &&
                    rect.width > 0 &&
                    rect.height > 0,
                  attributes: Array.from(elem.attributes).reduce(
                    (acc, attr) => {
                      acc[attr.name] = attr.value === '' ? true : attr.value;
                      return acc;
                    },
                    {},
                  ),
                };
              }),
            );
            return elemProps;
          }

          await locator.focus();
          return true;
        }

        throw new Error(
          `Error in mouse-focus-info-command for browser type ${session.browser.type}.`,
        );
      }

      return undefined;
    },
  };
}
